<template>
  <div class="sidebar-container ml" :class="{ 'collapse-width': isCollapse }">
    <div class="logo" :class="{ 'collapse-logo': isCollapse }">
      <img src="/imgs/pic_logo_big.png" alt v-show="downIcon" class="img1" />
      <img src="/imgs/pic_logo_smail.png" alt v-show="!downIcon" class="img2" />
    </div>
    <div class="left1 left2">
      <!--  -->
      <div @click="collect">
        <img
          src="../../../public/imgs/btn_packup.png"
          alt
          class="zhedie fm_left_img"
          @click="toggleSidebar"
          v-show="downIcon"
        />
        <img
          src="../../../public/imgs/btn_unfold.png"
          alt
          class="zhedie"
          @click="toggleSidebar"
          v-show="!downIcon"
        />
      </div>
      <el-menu
        class="el-menu-vertical-demo"
        text-color="#A9B8D6"
        active-text-color="#1f87ff"
        background-color="#303743"
        :collapse="isCollapse"
        :default-active="$route.path"
        :unique-opened="true"
        router
        @open="handleOpen"
        ref="elMenu"
        @select="handleSelect"
        v-for="v in moni"
        :key="v.id"
      >
        <el-submenu :index="`${v.id}`" v-if="v.submenu">
          <template slot="title">
            <img :src="`${v.img}`" alt="" class="fm_left_img" />
            <span slot="title">{{ v.name }}</span>
          </template>

          <el-menu-item-group v-for="item in v.submenu" :key="item.id">
            <el-menu-item :index="`${item.name1}`" :key="item.id">
              {{ item.name }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-menu-item
          v-for="item in v.submenu_stair"
          :key="item.id"
          :index="`${item.name1}`"
        >
          <img :src="`${item.img}`" alt="" />
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <!--        
            <router-link
              :to="{
                name: item.hasOwnProperty('params') ? item.params.__mode : '',
              }"
              tag="li"
            >  
              <router-link :to="`${item.name1}`">66</router-link>

           -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import { mapState } from "vuex";
import BreadCrumd from "./breadcrumb";
export default {
  inject: ["reload"],
  component: {
    BreadCrumd,
  },
 props: ["the_default_load"],
  computed: {
    onRoutes() {
      return this.$route.path.replace("/", "");
    },
    ...mapState({
      isCollapse: (state) => state.common.isCollapse,
    }),
  },
  data() {
    return {
      left: [],
      moni: [],
      sanji: [],
      eventopen: JSON.parse(sessionStorage.getItem("leftMenu")) || "",
      downIcon: true,
      default_lange: "",
      // zhu_is_show: JSON.parse(sessionStorage.getItem("usermsg"))
      //   ? JSON.parse(sessionStorage.getItem("usermsg")).zhu_is_show
      //   : 0,
    };
  },

  mounted() {
   
    // let  ceshi=[1,2,3]
    // for(let i=0;i<ceshi.length;i++){
    // }
    // let languse = JSON.parse(sessionStorage.getItem("usermsg"))
    //   ? JSON.parse(sessionStorage.getItem("usermsg")).lang == "en_US"
    //     ? "en_US"
    //     : "zh_CN"
    //   : "zh_CN";
    // this.default_lange = languse;
    // this.getLeft();
  },
  created() {
this.aaaa()

  },
  // beforeRouteUpdate(to, from, next) {
  //   // this.getLeft();

  //   next();
  // },
  watch: {
    $route(to, from) {
      // console.log(from,'watch');
      let url = from.path;
      if (url == this.$route.path) {
        // this.$router.replace('/home/kongbai')
        // console.log("跳转了,还没有");
        // console.log()
        // // this.$router.go(0);
        this.$router.push({
          path: "/home/kongbai",
          query: {
            url,
          },
        });
      }
    },
  },
  methods: {
    aaaa(){
// alert(222222)
      
     if(JSON.parse(sessionStorage.getItem("usermsg"))){
          this.getLeft();


      }else{
       console.log(222)
alert('请重新登录')
         this.$router.push("/login");
return false
      }
    },
    // 点击左侧菜单栏
    handleSelect(key) {
      // console.log(key, this.$route.path)

      if (key == this.$route.path) {
        // this.$router.replace('/home/kongbai')

        this.$router.push({
          path: "/home/kongbai",
          query: {
            key,
          },
        });

        // this.reload()
        // console.log('跳转了')
      } else {
        this.$router.push({
          path: key,
        });
      }
    },
    toggleSidebar() {
      this.downIcon = !this.downIcon;
    },
    // 判断
    collect() {
      this.downIcon = !this.downIcon;
    },

    ...mapActions(["toggleSidebar"]),
    tiao(a) {
      console.log(a);
      this.$router.push({
        path: a,
      });
    },

    // @open="handleOpen"
    handleOpen(key) {
      // console.log(key, keyPath, this.$route.path)
      this.$store.dispatch("checkLeftMenu", key);
      this.eventopen = key;
    },
    handTOP() {
      this.$refs.elMenu.close(this.eventopen);
    },
    // 切换

    // 数据
    getLeft() {
      
      //   // 模拟数据
      //   this.$axios.get("/json/a.json").then((res) => {
      //     console.log(res);
      //     if (this.default_lange == "zh_CN" || "") {
      //       this.moni = res.data.one;

      //     } else {
      //       this.moni = res.data.one1;

      //     }
      //     if( !JSON.parse(sessionStorage.getItem("judge"))){
      //       sessionStorage.setItem("judge", JSON.stringify(this.moni))

      //       }
      //   });

      // 一级
     

     
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      this.$axios
        .get("/api/adm/cgi/admin.cgi", {
          params: {
            // id: id,
            sid: sid,
            __mode: "show_json",
          },
        })
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            // this.$router.push({
            //     name: "login",
            // });
          } else {
         
            this.moni = res.data.ret.one;
            // this.the_default_load=1
           
          
            if (JSON.parse(sessionStorage.getItem("val")) == null) {
              console.log(this.$i18n.locale);
              this.$i18n.locale = JSON.parse(
                sessionStorage.getItem("usermsg")
              ).lang;
              // let redirect_index = JSON.parse(sessionStorage.getItem("usermsg"))
              //   .redirect;
              let redirect_index = "";
              console.log(this.moni[0]);
              if(this.moni[0]){
              if (this.moni[0].submenu_stair) {
                redirect_index = this.moni[0].submenu_stair[0].name1;
              } else if (this.moni[0].submenu) {
                redirect_index = this.moni[0].submenu[0].name1;
              }
              }
              console.log(redirect_index);
              this.$root.jurisdiction.only_query = JSON.parse(
                sessionStorage.getItem("usermsg")
              ).fm_not_readonly;
              console.log(this.$root.jurisdiction.only_query);
              this.$router.push({
                path: redirect_index,
              });

              sessionStorage.setItem("val", "1");

              //    window.location.reload();
            }
            setTimeout(() => {
                this.$emit('childFn', false);
              
            }, 800);

            if (!JSON.parse(sessionStorage.getItem("judge"))) {
              sessionStorage.setItem("judge", JSON.stringify(this.moni));
            }
          }
        });
 }
      // end
    
  },
};
</script>

<style lang="less" scoped>
//
// .left1 ul {
//     width: 190px;

//     // display: flex;
//     // flex-direction: column;
//     // justify-content: center;
//     // align-items: center;

//     /deep/ .el-submenuul {
//         display: flex;
//         flex-direction: column;
//         justify-content: center;
//         align-items: center;

//     }
// }
.shouye_left {
  padding-left: 22px !important;
}

/deep/ .el-menu-item.is-active {
  background: #006be7 !important;
  color: #fff !important;
}

/deep/ .router-link-active {
  border-bottom: 0;
}

.ml {
  display: flex;
  flex-direction: column;
  position: relative;
}

// 隐藏滚动条
.left1::-webkit-scrollbar {
  width: 0px;
  background: none;
}

// 按钮颜色
/deep/.el-button--primary {
  background-color: #e5e5e5;
  color: #000;
}

.ml .zhedie {
  // position: fixed;
  right: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5000;
}

.collapse-width .zhedie {
  // position: fixed;
  position: absolute;

  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5000;
}

.left1 {
  position: relative;
  margin: revert;
  // padding-right: 20px;
  margin-top: 4px;
  overflow: auto;
  flex: 1;
  text-align: left;
  background: #303743;
}

.el-menu--popup-right-start > .el-menu-item-group .el-menu-item {
  height: 36px !important;
  line-height: 36px !important;
  // min-width: 0px !important;
}

.el-menu--vertical > .el-menu--popup {
  padding: 0 !important;
}

// 折叠后
/deep/.el-menu--collapse .shouye_left div {
  padding-left: 22px !important;
}

.el-submenu .el-menu-item {
  min-width: auto;
}

// 首页 颜色

// .el-menu--collapse /deep/ .el-submenu__title {
//     height: 50px;
//     line-height: 50px;
// }

// 更改折叠后的位置
/deep/ .left1 .el-submenu__title {
  padding-left: 22px !important;
  background: #303743;
}

/deep/ .el-submenu__title {
  // padding-left: 30px !important;
  // img {
  //   padding-right: 10px;
  // }
  span {
    padding-left: 8px;
  }
}

// 行间距
/deep/ .el-submenu__title {
  height: 36px;
  line-height: 36px;
}
// 携程
// /deep/ .el-submenu__title {
//   height: 44px;
//   line-height: 44px;
// }
// /deep/ .el-submenu__icon-arrow{
// margin-top:-8px;
// font-size: 16px;
// }
.collapse-width {
  width: 64px !important;
}

.collapse-logo {
  font-size: 12px !important;
  width: 20px;

  h6 {
    display: none;
  }

  .img1 {
    width: 60px !important;
    height: 30px !important;
  }

  .img2 {
    width: 50px !important;
    height: auto !important;
  }
}

/deep/ .el-submenu__title:hover {
  background: #6db6ff !important;

  img {
    width: 20px;
    height: 20px;
  }
}

.sidebar-container {
  display: flex;
  flex-direction: column;
  width: 16%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  transition: width 0.28s;
  // z-index: 1001;
  overflow: hidden;

  .el-menu-vertical:not(.el-menu--collapse) {
    width: 180px;
  }

  .el-menu {
    border: none;
    background: #303743;
  }

  .logo {
    width: 100%;
    // height: 50px;
    // line-height: 50px;
    // padding-bottom: 10px;
    // border-bottom: 2px solid #9cb1dd;
    font-size: 30px;
    text-align: center;

    background: #303743;
    display: flex;
    flex-direction: column;
    color: #fff;
    align-items: center;

    h6 {
      //  background: #f0f;
      // font-size: 14px;
      font-family: "仿宋";
      font-size: 16px;
      // padding-top: 10px;
    }
  }
}

.logo img {
  width: 172px;
  height: auto;
  margin: 8px;
}

.el-menu--collapse {
  // width: 80px;
}

.left1 img {
  width: 18px;
  height: 19px;
  display: inline-block;
}
.fm_left_img {
  display: inline-block !important;
}
.left1 .zhedie {
  width: 16px;
  height: 40px;
}

// 二级高度
/deep/ .left1 .el-menu-item {
  // margin-left: -20px;
  // width: 100px;
  height: 34px;
  line-height: 34px;
  font-size: 14px;

  img {
    width: 18px;
    height: 18px;
    // margin-right: 10px;
  }
}

.el-menu-item img {
  padding-right: 10px;
}

/deep/ .el-menu--collapse {
  /deep/ .el-menu-item {
    // margin-left: -20px;
  }
}

/deep/ .el-submenu__title {
  padding-left: 44px !important;
  background: #303743;
}

// /deep/ .left1 .el-menu{
//   margin-left: 0px;

// }
// /deep/ .left2 .el-menu{
//   margin-left: 10px;

// }
.el-menu--collapse /deep/.el-menu-item {
  // margin-left: -20px;
  //
  height: 34px;
  line-height: 34px;
  font-size: 12px;

  img {
    width: 16px;
    height: 16px;
  }
}

/deep/ .el-menu-item-group__title {
  padding: 0px 0;
}

// /deep/ .el-menu-item-group {
//  width: 16px;
// }
/deep/ .is-opened {
  // display: block;

  // img {
  //     width: 14px;
  // }
}

// /deep/ .el-menu--popup {
//     padding: 0;
//     // min-width: 0;
// }

/deep/ .el-menu--collapse .el-menu--popup-right-star {
  margin-right: 0;
}
</style>
